// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"225":"layout","535":"login","804":"user-list","901":"resource-list"}[chunkId] || chunkId) + "." + {"225":"82d2a6e2","261":"adbc0382","535":"ffbc9da2","804":"af441430","901":"985f0b27"}[chunkId] + ".css";
};